import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@mui/system';
import { Alert } from '@mui/material';
import PaginationControlled from './PaginationControlled';
import CSVReport from './CSVReport';
import CSVconLLU from "./CSVconLLU";
import "./annot.css"
import Stack from "@mui/material/Stack";



export default function UD1({data}) {
    const [UDQueryInput, setUDQueryInput] = useState('');
    const [UDQueryResult, setUDQueryResult] = useState([]);
    const [message, setMessage] = useState('');
    const [transcription, setTranscription] = useState('dip');

    const handleChangeTranscription = (event) => {setTranscription(event.target.value)};



            function uDSelect1(e) {
        let opt = document.getElementsByClassName("opt1");

       for (let i = 0; i < opt.length; i++) {
			opt[i].style.display = "none";
			opt[i].classList.remove("act1");

		}

        const a = document.getElementById(e.target.value);

        if (a) {
            a.style.display = "";
		    a.classList.add("act1");

        }
	}

                function uDWrite1(e) {
                console.log("We are here!")
            e.preventDefault()
            let ud = document.getElementById("UD").value;
            if (ud !== "" ) {
                document.getElementById("input1").value = ud;

            let tags = document.getElementsByClassName("act1")[0]
                if (tags !== undefined) {
                    tags = tags.getElementsByClassName("tag1")
                }

            if (tags !== undefined) {
			for (let i = 0; i < tags.length; i++) {
				ud += tags[i].value;
			    }
			document.getElementById("input1").value = ud;
            }
            }

            let queryString = ud;
            if (queryString.includes(':?')) {
                  queryString = ud.replaceAll(':?', '.*');
                }
        setUDQueryInput(queryString)
	        }


    function handleChange(event) {
         let queryString = event.target.value;
        if (event.target.value.includes(':?')) {
            queryString = event.target.value.replace(':?', '.*');
        }
        setUDQueryInput(queryString);
    }

    function handleSubmit(e) {
      e.preventDefault()

      let answer = []
      for (const text of data) {
        let token_index =  2
        const text_name = text['text']
        if (transcription === 'cyr') {
          token_index = 1
        } else if (transcription === 'lat') {
          token_index = 0
        }

        for (const [, sentence] of Object.entries(text['sentences'])) {

          let lemmata  = [];
          let annotations = [];
          let tokens = [];
          let UDs = [];
          let sent_plain = '';
          let translation = '';
          let sentID = null;

          let udExt = [];
           let re = new RegExp(UDQueryInput);

            let annotationsExt = [];
          let UDsOfParents = [];

            for (const word of sentence) {
                sentID = word[6]
              sent_plain += word[token_index];
              sent_plain += ' ' ;
              tokens.push(word[token_index]);
              lemmata.push(word[3]);
              annotations.push(word[4]);
              word[10] ? UDs.push(`${word[9]}:${word[10]}`) : UDs.push(word[9]);
              UDsOfParents.push(word[8]);
              word[5] ? annotationsExt.push(word[5]) : annotationsExt.push('_');
              word[10] ? udExt.push(word[10]) : udExt.push('_');

              if (word[13]) {
                translation += word[13]
                translation += ' / '
              }

            }

            for (let i = 0; i < UDs.length; i++) {
              if (UDs[i].startsWith(UDQueryInput.toLowerCase()) || (UDs[i] + ':' + udExt[i]) === UDQueryInput || UDs[i].match(re)) {
             answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs, i, annotationsExt, UDsOfParents, sentID ])
            }
            }



        }
      }
      setUDQueryInput(UDQueryInput)
      setMessage(`Your query has given ${answer.length} results.`)
      setUDQueryResult(answer)
    }


    return (
        <>
  <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6}>
        <Stack direction={'column'}>
          <input id="input1" type="text" onChange={(e) => handleChange(e)} style={{width: "40%"}} placeholder={"*UD tag"} />

        <select style={{width: "30%", marginTop: "20px"}}
          value={transcription}
          onChange={handleChangeTranscription}
        >
          <option value={'lat'}>Latin</option>
          <option value={'cyr'}>Cyrillic</option>
          <option value={'dip'}>Diplomatic</option>
        </select>

         <button  type='submit'  disabled={!UDQueryInput}  onClick={handleSubmit} style={{width: "80px", marginTop: "20px"}}>Submit</button>

            </Stack>
        </Grid>


        <Grid item xs={6} style={{display: 'flex', flexWrap: 'wrap'}}>
         <form id="tagger1">
              <form>
                  <select id="UD"  onChange= {(e) => uDSelect1(e)}   >
                      <option value="">select main dependency</option>
                      <option value="root">sentence root</option>
                      <option value="acl">adnominal clause root</option>
                      <option value="advcl">adverbial clause root</option>
                      <option value="advmod">adverbial modifier</option>
                      <option value="amod">adjectival modifier</option>
                      <option value="appos">appositional modifier</option>
                      <option value="aux">auxilla</option>
                      <option value="case">analytic dependency marker</option>
                      <option value="cc">coordinating conjunction</option>
                      <option value="conj">conjunct</option>
                      <option value="cop">copula</option>
                      <option value="csubj">subject of a subordinate sentence</option>
                      <option value="det">determiner</option>
                      <option value="discourse">discourse marker</option>
                      <option value="expl">expletive</option>
                      <option value="fixed">element of multiple word expression</option>
                      <option value="mark">subordinating conjunction/marker</option>
                      <option value="nsubj">subject of the main sentence</option>
                      <option value="nmod">nominal modifier</option>
                      <option value="nummod">numeric modifier</option>
                      <option value="obj">direct object</option>
                      <option value="obl">oblique argument</option>
                      <option value="orphan">orphaned element (no direct head)</option>
                      <option value="punct">punctuation</option>
                      <option value="reparandum">stricken tokens (reparanda)</option>
                      <option value="vocative">vocative element</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="obl">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":abl">ablative relation</option>
                      <option value=":iobj">indirect object/recipient relation</option>
                      <option value=":lat">allative relation</option>
                      <option value=":loc">static locative relation</option>
                      <option value=":poss">possessor relation</option>
                      <option value=":pred">predicative modifier</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="det">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":ext">extended adnominal demonstrative</option>
                      <option value=":p_nom">postnominal article</option>
                      <option value=":p_adj">postadjectival article</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="aux">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="fixed">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="mark">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>
             <br/> <br/><input type="submit" value="write UD tag"   onClick={(e) => uDWrite1(e)}   />
          </form>
        </Grid>
      </Grid>
    </Box>


      <Box mt={2}>

      {message && <Alert severity="info">{message}</Alert>}

      </Box>

      <CSVReport searchResult={UDQueryResult}  domain="UD"/>
           <br/>
          <CSVconLLU searchResult={UDQueryResult} />

      <br/>

      <PaginationControlled queryResult={UDQueryResult} query={UDQueryInput} domain="UD"  trans={transcription}/>

            </>
    );
  }